import React from "react";

import { useTranslation } from "react-i18next";

import { Text, Divider } from "@mantine/core";

import { MightierCheckbox } from "@components/MightierCheckbox/index";

import cx from "../account_activate_form.module.css";

import type { AccountActivateForm } from "src/services/accountActivation/accountActivationTypes";

export const NotificationPreferences: React.FC<{
  form: AccountActivateForm;
}> = ({ form }) => {
  const { t } = useTranslation();
  return (
    <div data-testid="notification-preferences-form-part">
      <Text className={cx["terms-text"]}>
        {t("startPage.termsConditionsAndSubscriptions")}
      </Text>
      <MightierCheckbox
        {...form.getInputProps("isMailOk", { type: "checkbox" })}
        label={t("startPage.yesSkillPack")}
        data-testid="notification-mail-checkbox"
      />

      <Divider className={cx.divider} />

      <MightierCheckbox
        {...form.getInputProps("isEmailOk", { type: "checkbox" })}
        label={t("startPage.yesUpdatesTipsNews")}
        data-testid="notification-email-checkbox"
      />

      <MightierCheckbox
        {...form.getInputProps("isSmsOk", { type: "checkbox" })}
        label={t("startPage.yesSetupInstructions")}
        data-testid="notification-sms-checkbox"
      />
    </div>
  );
};
